import { useMutation } from '@tanstack/react-query';

import { disconnectGoCardless } from '../api';
import { goCardlessMutationKeys } from '../data';

export const useDisconnectGoCardless = () => {
  const mutation = useMutation({
    mutationKey: goCardlessMutationKeys.disconnect,
    mutationFn: disconnectGoCardless,
  });

  return mutation;
};
